var SubmitModelV2 = function(pageModelHndl) {
    var that = this;

    that.ArticleReference = ko.observable();
    that.Amount = ko.observable();
    that.SelectedOrderOptions = ko.observable();
    that.ItemCount = ko.observable();

    that.PopulateSubmitModel = function() {
        that.ArticleReference(pageModelHndl.pPriceTableModelV2.ArticleReference());
        that.Amount(pageModelHndl.pPriceTableModelV2.Amount());

        that.SelectedOrderOptions(new SelectOrderOptionsModel(pageModelHndl));

        that.ItemCount(pageModelHndl.SelectedItemCount());
    }
};

var SelectOrderOptionsModel = function(pageModelHndl) {
    var that = this;

    that.CountryId = ko.observable(2);
    that.DeliveryOptionId = ko.observable(1);
    that.DataCheckId = ko.observable(1);
    that.ProofId = ko.observable(1);
    that.HotfoilId = ko.observable(1);
    that.FileFormatId = ko.observable(1);
    that.FileTransferId = ko.observable(1);
    that.ProductionTimeId = ko.observable(1);
    that.PrintMethodId = ko.observable(1);
    that.PaintworkId = ko.observable(1);
    that.BundlingId = ko.observable(1);
};